import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const HeroWidget: WidgetRegistryEntry = {
  name: "Hero",
  component: () => import("./hero-widget.component").then((c) => c.HeroWidgetComponent),
  configuration: () => import("./configuration").then((c) => c.HeroWidgetConfiguration)
};
